module.exports = __webpack_public_path__ + "static/img/footer.920d719.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Head/footer.jpg
// module id = hZBq
// module chunks = 0